import Axios from 'raypro_ui/src/api/axios_wrapper'

export function getPreopPatientQuestionnaires(patientId) {
  return Axios({
    url: `/patients/${patientId}/preop_patient_questionnaires`,
    method: 'GET'
  })
}

export function createPreopPatientQuestionnaire(patientId, data) {
  return Axios({
    url: `/patients/${patientId}/preop_patient_questionnaires`,
    method: 'POST',
    data: data,
  })
}

export function getPatientQuestionnaires(patientId) {
  return Axios({
    url: `/patients/${patientId}/patient_questionnaires`,
    method: 'GET'
  })
}

export function getPatientQuestionnaire(id, questionnaireId) {
  return Axios({
    url: `/patients/${id}/patient_questionnaires/${questionnaireId}`,
    method: 'GET'
  })
}

export function getPatientTranslations(id, prefix) {
  return Axios({
    url: `/patients/${id}/translations?prefix=${prefix}`,
    method: 'GET'
  })
}

export function createQuestionnaireAnswer(questionId, data) {
  return Axios({
    url: `/questions/${questionId}/patient_questionnaire_answers`,
    data: data,
    method: 'POST'
  })
}

export function updateQuestionnaireAnswer(answerId, data) {
  return Axios({
    url: `/patient_questionnaire_answers/${answerId}`,
    data: data,
    method: 'PATCH'
  })
}

export function getQuestionnaireAnswer(questionId, patientId, questionnaireId) {
  return Axios({
    url: `/questions/${questionId}/patient_questionnaire_answers?patient=${patientId}&questionnaire=${questionnaireId}`,
    method: 'GET'
  })
}

export function getQuestionnaires() {
  return Axios({
    url: `/questions`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/api/questionnaire.js